export const projectType = [
  {
    name: 'Project type*',
    value: 'Project type*',
  },
  { name: 'Aged Care', value: 'aged-care' },
  { name: 'Healthcare', value: 'healthcare' },
  { name: 'Commercial', value: 'commercial' },
  { name: 'Multi Residential & New Build', value: 'multi-res' },
  { name: 'Consumer', value: 'consumer' },
  { name: 'Builder', value: 'builder' },
  { name: 'Education', value: 'education' },
  { name: 'Office', value: 'office' },
  { name: 'Retail & Hospitality', value: 'retail-hospitality' },
  { name: 'Hotel', value: 'hotel' },
  { name: 'Entertainment & Transport', value: 'entertainment-transport' },
  { name: 'Government & Defense', value: 'government-defense' },
  { name: 'Residential', value: 'residential' },
  { name: 'Industrial', value: 'industrial' },
  { name: 'Other', value: 'others' },
];

export const projectObj: any = {
  'aged-care': 'Aged Care',
  healthcare: 'Healthcare',
  commercial: 'Commercial',
  'multi-res': 'Multi Residential & New Build',
  consumer: 'Consumer',
  builder: 'Builder',
  education: 'Education',
  office: 'Office',
  'retail-hospitality': 'Retail & Hospitality',
  hotel: 'Hotel',
  'entertainment-transport': 'Entertainment & Transport',
  'government-defense': 'Government & Defense',
  'residential': 'Residential',
  'industrial': 'Industrial',
  'others': 'Other',
};

export const PHONE_PATTERN = /^[0-9]+$/;
// export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const EMAIL_PATTERN = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const projectLocation = [
  {
    name: 'Project Location*',
    value: 'Project Location*',
    region: '*',
  },
  { name: 'National', value: 'National', region: 'au' },
  { name: 'ACT', value: 'ACT', region: 'au' },
  { name: 'NSW', value: 'NSW', region: 'au' },
  { name: 'NT', value: 'NT', region: 'au' },
  { name: 'QLD', value: 'QLD', region: 'au' },
  { name: 'SA', value: 'SA', region: 'au' },
  { name: 'TAS', value: 'TAS', region: 'au' },
  { name: 'VIC', value: 'VIC', region: 'au' },
  { name: 'WA', value: 'WA', region: 'au' },
  { name: 'North Island', value: 'North Island', region: 'nz' },
  { name: 'South Island', value: 'South Island', region: 'nz' },
];

export const projectStatus = [
  {
    name: 'Project status*',
    value: 'Project status*',
  },
  { name: 'Open', value: 'open' },
  { name: 'Close', value: 'closed' },
];

export const capitalizeFirstLetter = (str: string) => str?.charAt(0)?.toUpperCase() + str?.slice(1);

export const ctDataToFormData = (ctData: any) => {
  const roomDataMap: Record<string, { count: number; value: number[] }> = {};
  ctData?.roomLabels?.forEach((label: string) => {
    const match = label.match(/(.*?)(\d+)?$/);
    if (match) {
      const roomName = match[1].trim();
      const roomNumber = match[2] ? parseInt(match[2], 10) : 1;

      if (!roomDataMap[roomName]) {
        roomDataMap[roomName] = { count: 0, value: [] };
      }
      const values = roomDataMap[roomName].value;
      let nextNumber = roomNumber;
      while (values.includes(nextNumber)) {
        nextNumber += 1;
      }
      roomDataMap[roomName].value.push(nextNumber);
      roomDataMap[roomName].count = roomDataMap[roomName].value.length;
    }
  });

  const result = Object.entries(roomDataMap)?.map(([roomName, { count, value }]) => ({
    roomName,
    count,
    value,
  }));

  return {
    ...ctData,
    projectLocation: {
      name: ctData?.projectLocation,
      value: ctData?.projectLocation,
    },
    projectType: {
      name: projectObj[ctData?.projectType] ?? capitalizeFirstLetter(ctData?.projectType),
      value: ctData?.projectType,
    },
    projectStatus: {
      name: capitalizeFirstLetter(ctData?.status),
      value: ctData?.status,
    },
    selectedRoomDetails: result,
    customerEmail: ctData?.customerDetails?.email,
    customerName: ctData?.customerDetails?.name,
    customerAddress:ctData?.customerDetails?.customerAddress,
    customerPhone: ctData?.customerDetails?.phone,
  };
};

export const errorData = {
  skuInvalid: 'Invalid SKU present',
  skuNotAvailable: 'SKU not available',
  qtyInvalid: 'Invalid QTY present',
  qtyNotAvailable: 'Qty not available',
  qtyExceedsMax: 'Quantity exceeds maximum allowed (9999)',
  totalQtyExceedsMax: 'Total quantity exceeds maximum allowed (9999) for the project',
  sectionInvalid: 'Invalid Section present',
  sectionNotAvailable: 'Section not available',
  addedSuccessfully: 'Successfully added',
  productNotFound: 'Product not found',

  inValidFileFormat: 'Invalid file. Please upload correct file.',
  emptyFile: 'File does not contain any data.',
  inValidProducts: 'File contain invalid products. Please upload correct file.',
  moreItems: 'Cannot import more than 250 line items.',
};
